import { IdentityPopover } from '@/accessControl/IdentityPopover.molecule';
import type { Ace } from '@/accessControl/itemAclModal.utilities';

interface AcePopoverProps {
  ace: Ace;
}

export const AcePopover = ({ ace }: AcePopoverProps) => {
  return ace.identity ? <IdentityPopover identity={ace.identity} /> : null;
};
